/**
 * Environment configuration settings for Chess Codebreaker
 * 
 * This file contains environment-specific settings that control
 * application behavior across different environments.
 */

/**
 * Parses REACT_APP_FORCE_DEBUG as a boolean override.
 * Accepted true values: "true", "1", "yes", "on" (case-insensitive)
 */
const getEnvForceDebug = (): boolean => {
  const raw = process.env.REACT_APP_FORCE_DEBUG;
  if (!raw) return false;
  return ['true', '1', 'yes', 'on'].includes(raw.toLowerCase());
};

/**
 * Parses REACT_APP_DISABLE_DEBUG as a boolean override.
 * Accepted true values: "true", "1", "yes", "on" (case-insensitive)
 */
const getEnvDisableDebug = (): boolean => {
  const raw = process.env.REACT_APP_DISABLE_DEBUG;
  if (!raw) return false;
  return ['true', '1', 'yes', 'on'].includes(raw.toLowerCase());
};

/**
 * Determines if debug features should be enabled
 * 
 * Default behavior:
 * - test: disabled unless explicitly forced on
 * - other environments (including production): enabled by default
 *
 * Override behavior:
 * - REACT_APP_DISABLE_DEBUG always disables
 * - REACT_APP_FORCE_DEBUG force-enables for test environments
 */
export const isDebugEnabled = (): boolean => {
  if (getEnvDisableDebug()) {
    return false;
  }

  if (process.env.NODE_ENV === 'test') {
    return getEnvForceDebug();
  }

  return true;
};
